import React, { memo, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useInView } from 'react-intersection-observer';

import styles from './GameRankItem.module.less';
import { CONTEXT } from '../../../config';
import ItemGame from './ItemGame';
import ItemGameActive from './ItemGameActive';
import _LogInView from '../../_LogInView/_LogInView';
import { logging, logPostInfo } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ indexKey, rankInfo, logInfo, data }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeIndex, setActiveIndex] = useState(0);
  const logInfoData = useSelector(selectLogInfo);

  const [refInview75, inView75] = useInView({
    threshold: 0.75,
  });

  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.clTag || logInfo.tag}_Rank_More`,
    source_app: `${logInfo.clTag || logInfo.tag}_Rank`,
    source: `${logInfo.tag}_Rank`,
  };

  useEffect(() => {
    if (inView75) {
      dispatch(
        logging({
          category: 'I',
          action: `Game_Content_Show`,
          label: '',
          param2: {
            pageCardTitle: data && data.title,
            cardType: data && data.cardType,
            pageCardId: rankInfo.pageCardContentId ?? '',
            rankCode: rankInfo.code ?? '',
            org: rankInfo.org || '',
            source: logInfo.tag,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [inView75]);

  const backgroundIndex = index => {
    let i = index % 6;
    switch (i) {
      case 0:
        return styles.bg0;
        break;
      case 1:
        return styles.bg1;
        break;
      case 2:
        return styles.bg2;
        break;
      case 3:
        return styles.bg3;
        break;
      case 4:
        return styles.bg4;
        break;
      case 5:
        return styles.bg5;
        break;
    }
  };

  const handleMore = () => {
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_more,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${rankInfo.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/rankmore_game?code=${rankInfo.code}`);
  };

  return (
    <div className={`${styles.item_rank} ${backgroundIndex(indexKey)}`} ref={refInview75}>
      <div className="item_rank_header">
        <div className="item_rank_title">
          {rankInfo?.nameBackgroundImg ? (
            <img src={rankInfo?.nameBackgroundImg} />
          ) : (
            <div className="desc">{rankInfo?.name}</div>
          )}
        </div>
        <div className="more" onClick={() => handleMore()}>
          更多
        </div>
      </div>
      <div className="item_rank_content">
        {rankInfo?.apps.slice(0, 5).map((app, i) => (
          <div key={i} onMouseEnter={() => setActiveIndex(i)}>
            {i === activeIndex ? (
              <ItemGameActive
                soft={app}
                topIndex={i}
                logInfo={{
                  ...logInfo,
                  // tag: logTag,
                  source: `${LOG_ACTION_SOURCE.source}||${rankInfo.pageCardContentId}`,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  pageCardId: rankInfo.pageCardContentId,
                  rankCode: rankInfo.code,
                  org: rankInfo.org,
                  cardType: data?.cardType,
                  pageCardTitle: rankInfo.name,
                }}
              />
            ) : (
              <ItemGame
                soft={app}
                topIndex={i}
                logInfo={{
                  ...logInfo,
                  // tag: logTag,
                  source: `${LOG_ACTION_SOURCE.source}||${rankInfo.pageCardContentId}`,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  pageCardId: rankInfo.pageCardContentId,
                  rankCode: rankInfo.code,
                  org: rankInfo.org,
                  cardType: data?.cardType,
                  pageCardTitle: rankInfo.name,
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
});
